<!--<div class="app" [ngClass]="{'combined': settings.theme.skin == 'combined',
                            'light': settings.theme.skin == 'light',
                            'dark': settings.theme.skin == 'dark',
                            'blue': settings.theme.skin == 'blue',
                            'green': settings.theme.skin == 'green',
                            'navbar-fixed': settings.theme.navbarIsFixed,
                            'sidebar-fixed': settings.theme.sidebarIsFixed, 
                            'horizontal-menu': settings.theme.menu == 'horizontal',                                      
                            'compact': settings.theme.menuType == 'compact', 
                            'mini': settings.theme.menuType == 'mini',
                            'menu-hide': !settings.theme.showMenu }">
    <div class="wrapper">
        <router-outlet></router-outlet>
    </div> 
</div>-->
<div class="app"  [ngClass]="settings2.panel.skin" 
                  [class.navbar-fixed]="settings2.panel.navbarIsFixed"  
                  [class.sidebar-fixed]="settings2.panel.sidebarIsFixed"  
                  [class.horizontal-menu]="settings2.panel.menu == 'horizontal'" 
                  [class.compact]="settings2.panel.menuType == 'compact'" 
                  [class.mini]="settings2.panel.menuType == 'mini'" 
                  [class.menu-hide]="!settings2.panel.showMenu">
    <div class="wrapper">
        <router-outlet></router-outlet>
    </div> 
 
</div>
 <ng-template confirm>
      <confirm-modal-component></confirm-modal-component>
</ng-template> 
<ng-template alert>
    <alert-modal-component></alert-modal-component>
</ng-template> 